/* eslint-disable no-extra-boolean-cast */
/* eslint-disable react-native/no-inline-styles */
/**
 * CategoryItems Component
 * 
 * Displays items for a specific category
 * Features:
 * - Collapsible accordion for mobile (shows/hides items)
 * - Flat list for tablet (always expanded)
 * - Search filter support
 * - Item count in category header
 * - Default expand/collapse state from company settings
 * 
 * @component
 * @param {Object} category - Category object with id and name
 * @param {string} searchQuery - Search filter text
 * @param {Object} canteen - Canteen object
 * @param {boolean} isTablet - Whether device is tablet
 */
import React from 'react';
import { FlatList, View } from 'react-native';
import { Divider, List } from 'react-native-paper';
import { useSelector } from 'react-redux';
import Item from './Item';

function CategoryItems({ category, searchQuery, canteen, isTablet }) {
    const customer = useSelector(state => state.customer.customer);
    const _items = useSelector(state => state.canteen.items);
    let items = _items.filter(item => item?.category_id === category.category_id);
    if (!!searchQuery) {
        items = items.filter(item => (item.item_name).toLowerCase().includes(searchQuery.toLowerCase()));
    }
    const [expanded, setExpanded] = React.useState(customer?.company_settings?.category_collapse ?? true);
    const handlePress = () => setExpanded(!expanded);
    const renderItem = ({ item }) => <Item canteen={canteen} item={item} disableFav={true} />;


    if (isTablet) {
        return (
            <FlatList
                data={items}
                renderItem={renderItem}
                ListHeaderComponent={<Divider theme={{ colors: { outlineVariant: '#e7e7e7' } }} />}
                ItemSeparatorComponent={<Divider theme={{ colors: { outlineVariant: '#e7e7e7' } }} />}
                keyExtractor={(item) => (item?.item_id).toString()}
            />
        );
    }

    return (
        <React.Fragment>
            {items.length > 0 && <View style={{ marginBottom: 4 }}>
                <List.Accordion
                    title={category?.category_name + '(' + items.length + ')'}
                    expanded={expanded}
                    style={{ backgroundColor: '#ffffff', paddingVertical: 0 }}
                    titleStyle={{ fontSize: 14, textTransform: 'capitalize' }}
                    onPress={handlePress}>
                    <FlatList
                        data={items}
                        renderItem={renderItem}
                        ListHeaderComponent={<Divider theme={{ colors: { outlineVariant: '#e7e7e7' } }} />}
                        ItemSeparatorComponent={<Divider theme={{ colors: { outlineVariant: '#e7e7e7' } }} />}
                        keyExtractor={(item) => (item?.item_id).toString()}
                    />
                </List.Accordion>
            </View>
            }
        </React.Fragment>
    );
}

export default CategoryItems;
